import ReactDOM from 'react-dom/client';
import BuzonDelivery from './BuzonDelivery';
import { SpinnerProvider } from './context/spinnerContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <SpinnerProvider>
    <BuzonDelivery />
  </SpinnerProvider>
);

